var _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageTool(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.771 1.84619H1.23257C0.892705 1.84619 0.617188 2.12171 0.617188 2.46158V13.5385C0.617188 13.8784 0.892705 14.1539 1.23257 14.1539H14.771C15.1109 14.1539 15.3864 13.8784 15.3864 13.5385V2.46158C15.3864 2.12171 15.1109 1.84619 14.771 1.84619Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.617188 11.0767L4.48973 7.20417C4.54687 7.14702 4.61471 7.1017 4.68937 7.07077C4.76403 7.03984 4.84406 7.02393 4.92487 7.02393C5.00568 7.02393 5.0857 7.03984 5.16037 7.07077C5.23503 7.1017 5.30287 7.14702 5.36001 7.20417L8.79742 10.6416C8.85456 10.6987 8.9224 10.744 8.99706 10.775C9.07173 10.8059 9.15175 10.8218 9.23256 10.8218C9.31337 10.8218 9.3934 10.8059 9.46806 10.775C9.54272 10.744 9.61056 10.6987 9.6677 10.6416L11.259 9.05032C11.3161 8.99318 11.3839 8.94785 11.4586 8.91692C11.5333 8.886 11.6133 8.87008 11.6941 8.87008C11.7749 8.87008 11.8549 8.886 11.9296 8.91692C12.0043 8.94785 12.0721 8.99318 12.1292 9.05032L15.3864 12.3075",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1535 6.76901C10.6633 6.76901 11.0766 6.35573 11.0766 5.84593C11.0766 5.33613 10.6633 4.92285 10.1535 4.92285C9.64374 4.92285 9.23047 5.33613 9.23047 5.84593C9.23047 6.35573 9.64374 6.76901 10.1535 6.76901Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageTool);
export default __webpack_public_path__ + "static/media/image-tool.157e4a87768e3777f5a3ea1f7e38664e.svg";
export { ForwardRef as ReactComponent };